import { EntityNotesProvider, useEntityNotesContext } from "./context/EntityNotesContext";
import { useEntityManagerContext } from "../../entityManager/context/EntityManagerContext";
import { DashboardCard } from "@/modern/components/dashboard-card";
import { EmptyNotesState } from "./components/EmptyNotesState";
import { NotesList } from "./components/NotesList";
import { NotePreview } from "./components/NotePreview";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { Tooltip } from "@/modern/components/ui/tooltip";
import { Button } from "@/modern/components/ui/button-shadcn";
import { CardTitle } from "@/modern/components/ui/card";
import { cn } from "@/modern/utils";
import { ArrowLeft, Expand, PlusIcon } from "lucide-react";
import { useRef } from "react";

const EntityNotesViewContent = () => {
  const { hasNotes, selectedNote, isSelectedNote, handleClearSelectedNote, handleOpenEditor, canEditSelectedNote } = useEntityNotesContext();
  const richEditorContentElementRef = useRef<HTMLDivElement>(null);

  return (
    <DashboardCard
      className="h-[30rem]"
      cardContentClassName="h-full flex flex-col p-0"
      header={
        <div className="flex items-center justify-between w-full">
          <CardTitle className={cn("text-base gap-3 flex items-center truncate min-w-0", selectedNote.noteRecord?.archived && "line-through")}>
            {isSelectedNote && (
              <Button variant="ghost" size="icon" className="size-7 p-0 text-muted-foreground" onClick={() => handleClearSelectedNote()}>
                <ArrowLeft className="size-4" />
              </Button>
            )}
            <span className="truncate min-w-0 pr-2">
              {isSelectedNote ? (selectedNote.noteRecord?.name || "Untitled Note") : "Notes"}
            </span>
          </CardTitle>
          <ButtonGroup>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="entityHeader" className={cn(selectedNote.noteRecord && "w-auto px-3")} size="icon" onClick={() => handleOpenEditor(selectedNote.noteRecord || undefined, !isSelectedNote)}>
                  {isSelectedNote ? (
                    <>
                      <Expand className="size-4" /> {canEditSelectedNote && "Edit"}
                    </>
                  ) : (
                    <>
                      <PlusIcon className="size-4" />
                    </>
                  )}
                </Button>
              </TooltipTrigger>
              <TooltipContent>{isSelectedNote ? `${canEditSelectedNote ? "Edit" : "View"} note` : "Add note"}</TooltipContent>
            </Tooltip>
          </ButtonGroup>
        </div>
      }
    >
      <div ref={richEditorContentElementRef} className="h-full flex flex-col gap-4 relative">
        {hasNotes ? (
          <>
            {selectedNote.noteRecord ? (
              <NotePreview contentElementRef={richEditorContentElementRef} readOnly={true} />
            ) : (
              <NotesList />
            )}
          </>
        ) : (
          <EmptyNotesState />
        )}
      </div>
    </DashboardCard>
  );
};

export const EntityNotesView = () => {
  const { record } = useEntityManagerContext();
  return (
    <EntityNotesProvider entityRecord={record}>
      <EntityNotesViewContent />
    </EntityNotesProvider>
  );
};